// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2reBw","largestCol":"styles_largestCol__36Hi3","smallestCol":"styles_smallestCol__1czPK"};